import { render, staticRenderFns } from "./SideBarItem.vue?vue&type=template&id=448a8e02"
import script from "./SideBarItem.vue?vue&type=script&lang=js"
export * from "./SideBarItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('448a8e02')) {
      api.createRecord('448a8e02', component.options)
    } else {
      api.reload('448a8e02', component.options)
    }
    module.hot.accept("./SideBarItem.vue?vue&type=template&id=448a8e02", function () {
      api.rerender('448a8e02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/sideBar/SideBarItem.vue"
export default component.exports